<template>
</template>
<script>
import SessionResource from '../backend-resources/session-resource'
export default {
  created: function () {
    localStorage.removeItem('customerInfo')

    let sr = new SessionResource()
    sr.destroy().then((response) => {
      this.$store.commit('logout')
      this.$router.push('/login')
    })
    .catch(() => {
      this.$router.push('/login')
      this.$store.commit('logout')
    })
  }
}
</script>



// WEBPACK FOOTER //
// Logout.vue?29f8de41